import React, { useEffect, useRef, useState } from "react";
import { FaBell, FaEnvelope, FaSearch } from "react-icons/fa";
import { IoLogOut } from "react-icons/io5";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import ToastFile from "../utils/ToastFile";
import { Button } from "react-bootstrap";
import DailyTaskLogo from "../assets/images/DailyTaskLogo.png";

const Header = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isSmallMobile, setIsSmallMobile] = useState(window.innerWidth <= 375);
  const [showNotif, setShowNotif] = useState(false);
  const [notifAnim, setNotifAnim] = useState(false);
  const bellRef = useRef(null);
  const navigate = useNavigate();
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      setIsSmallMobile(window.innerWidth <= 375);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  // Animation control
  useEffect(() => {
    if (showNotif) {
      setTimeout(() => setNotifAnim(true), 10); // trigger animation
    } else {
      setNotifAnim(false);
    }
  }, [showNotif]);

  // Close on click outside
  useEffect(() => {
    if (!showNotif) return;
    const handleClick = (e) => {
      if (bellRef.current && !bellRef.current.contains(e.target)) {
        setNotifAnim(false);
        setTimeout(() => setShowNotif(false), 200);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [showNotif]);

  const openNotif = () => {
    setShowNotif(true);
  };

  const closeNotif = () => {
    setNotifAnim(false);
    setTimeout(() => setShowNotif(false), 200);
  };
  useEffect(() => {
    // Initialize Bootstrap tooltip
    const tooltipTrigger = document.getElementById("logout-tooltip");
    if (tooltipTrigger && window.bootstrap) {
      new window.bootstrap.Tooltip(tooltipTrigger);
    }
  }, []);

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    ToastFile("Logout successful.", "added");
    navigate("/");
  };
  return (
    <>

<nav
  className="navbar navbar-expand-lg shadow-sm"
  style={{
    background: "linear-gradient(90deg, #f09819, #ff5858)", // gradient
    padding: "16px 24px",
    //position: "sticky",
    top: 0,
    zIndex: 1,
    flexWrap:'nowrap'
  }}
>
  <div
    className="d-flex align-items-center me-auto"
    style={{
      width: isSmallMobile ? "200px" : isMobile ? "300px" : "350px",
    }}
  >
    <h2
      style={{
        color: "#fff",
        fontSize: isSmallMobile ? "22px" : "28px",
        fontWeight: "bold",
        letterSpacing: "1px",
        margin: 0,
        paddingLeft:isMobile?"50px": "0px",
        textShadow: "1px 1px 3px rgba(0,0,0,0.3)",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      }}
    >
      Daily Post Hub
    </h2>
  </div>

  <ul className="navbar-nav align-items-center d-flex flex-row">
    <li className="nav-item mx-2" style={{ cursor: "pointer" }}>
      {/* Desktop View */}
      <Button
        variant="light"
        size="sm"
        onClick={logout}
        className="d-none d-md-block"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          fontWeight: "500",
        }}
      >
        Logout <IoLogOut size={20} />
      </Button>

      {/* Mobile View */}
      <Button
        variant="light"
        size="sm"
        onClick={logout}
        className="d-md-none"
        style={{ padding: "6px 10px" }}
      >
        <IoLogOut size={20} />
      </Button>
    </li>
  </ul>
</nav>
    </>
  );
};

export default Header;
